import { useEffect, useRef, useState } from 'react'
import {
  CircularProgress,
  Container,
  Dialog,
  Grid,
  makeStyles,
  TextField,
  Button,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  InputLabel,
  FormControl,
  Select,
  MenuItem,
  FormHelperText,
  Box,
  Chip,
  IconButton,
  useMediaQuery,
  useTheme,
} from '@material-ui/core'
import {
  Datagrid,
  List,
  Notification,
  SaveButton,
  Toolbar,
  useDataProvider,
  useNotify,
  useTranslate,
  TextField as TextFieldRa,
  DateField,
  Link,
  SearchInput,
  TextInput,
  SelectInput,
  useRefresh,
  useUpdate,
  BooleanInput,
  useRecordContext,
  useGetOne,
  Loading,
  FilterButton,
  FilterForm,
  ReferenceInput,
  AutocompleteInput,
  required,
  SimpleForm,
  NumberInput,
  BulkExportButton,
  useListContext,
  BulkUpdateButton,
  AutocompleteArrayInput,
} from 'react-admin'
import {
  CloudDownload,
  Delete,
  Add,
  Link as LinkIcon,
  LinkOff,
  Unarchive,
  Verified as VerifiedIcon,
  Receipt as ReceiptIcon,
  PendingActions as PendingActionsIcon,
  AttachFile,
} from '@mui/icons-material'
import CustomFileInput from './custom_file_input'
import ServerUpload from '../exceptions/file_with_context_result/server_upload'
import FileWithContext from '../models/file_with_context'
import FileWithContextResult from '../models/file_with_context_result'
import Relation from '../models/relation'
import { Emoji, openInNewTab } from '../utils'
import ErrorUpload from '../exceptions/file_with_context_result/error_upload'
import TextFieldWithTooltip from './text_field_with_tooltip'
import { TranslateWrapperTextField } from './translatable_field_wrapper'
import VisibilityIcon from '@mui/icons-material/Visibility'
import CollapseMoreIcon from '@mui/icons-material/ExpandMore'
import CollapseExpandLessIcon from '@mui/icons-material/ExpandLess'
import CloudUploadIcon from '@mui/icons-material/CloudUpload'
import Api from '../Apis/api.service'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'

const moment = require('moment')

const useStyles = makeStyles(() => ({
  unsetPaddingFromSelectPresta: {
    '&> form .MuiCardContent-root': {
      padding: 0,
    },
  },
  buttonsContainer: {
    textAlign: 'right',
    verticalAlign: 'middle',
    display: 'flex',
    alignItems: 'right',
    justifyContent: 'right',
    marginLeft: 'auto',
  },
  deleteButton: {
    marginLeft: '1rem',
  },
  selectStyle: {
    '& label': {
      left: '12px',
    },
    '& label[data-shrink="true"]': {
      top: '8px',
    },
  },
  container: { width: 'unset', margin: '0' },
  panel: {
    borderRadius: 5,
    width: '100%',
    margin: '0',
    boxShadow: '4px 3px 20px -4px #b4bfd8',
  },
  panelContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    cursor: 'pointer',
    height: '46px',
    padding: '2px',
  },
}))

const CoproInput = (props) => {
  let { showCoproSelection, record, onChange } = props
  if (showCoproSelection) {
    return (
      <Grid item md={12} xs={12}>
        <SimpleForm record={record} toolbar={false} actions={false}>
          <ReferenceInput
            label="Code Copro"
            source="copro_id"
            reference="file_with_context/copros"
          >
            <AutocompleteInput
              onChange={(e) => {
                onChange(e)
              }}
              fullWidth
              optionText="code"
              optionValue="id"
              matchSuggestion={() => true}
              validate={[required()]}
            />
          </ReferenceInput>
        </SimpleForm>
      </Grid>
    )
  }
  return null
}
const PrestaInput = (props) => {
  const classes = useStyles()
  let { showPrestaSelection, record, onChange } = props
  if (
    showPrestaSelection &&
    ([FileWithContext.TYPE.INVOICE].indexOf(record.type) > -1 ||
      [FileWithContext.TYPE.QUOTE].indexOf(record.type) > -1)
  ) {
    return (
      <Grid
        item
        md={12}
        xs={12}
        className={classes.unsetPaddingFromSelectPresta}
      >
        <SimpleForm record={record} toolbar={false} actions={false}>
          <ReferenceInput
            label="Prestataire"
            source="provider"
            reference="prestas"
          >
            <AutocompleteInput
              onChange={(e) => {
                onChange(e)
              }}
              fullWidth
              optionText="name"
              optionValue="id"
              matchSuggestion={() => true}
              validate={[required()]}
            />
          </ReferenceInput>
        </SimpleForm>
      </Grid>
    )
  } else {
    return null
  }
}

const BasicForm = ({
  record,
  setRecords,
  setPristine,
  idx,
  isLast,
  validTypes,
  validCategories,
  validAccountantType,
  documentType,
  issuedBy,
  copro_id,
  staff_id,
  provider,
  limitQuantity = false,
  requiredField,
  errors = [],
  readOnly,
  children,
  show_shared_select = false,
  formSubmited,
  showCoproSelection = false,
  showPrestaSelection = false,
  defaultCollapsed = false,
  defaultValues = {},
  getDefaultCondo,
  setVerificationStatus,
  setVerifiedCount,
}) => {
  const translate = useTranslate()
  const [collapse, setCollapse] = useState(
    defaultCollapsed || record.id ? false : true
  )
  const [internalErrors, setInternalErrors] = useState(errors)
  const [isMatchingCondo, setIsMatchingCondo] = useState(false)

  const filtreTypesByCategory = (value) => {
    const contractTypes = Object.keys(FileWithContext.TYPE.CONTRACT).map(
      (key) => FileWithContext.TYPE.CONTRACT[key]
    )

    let new_type = defaultTypes
    switch (value) {
      case FileWithContext.CATEGORY.CONTRACT:
        new_type = [
          ...defaultTypes.filter((t) => contractTypes.includes(t.id)),
          {
            id: FileWithContext.TYPE.OTHERS,
            name: `hs.file.type.${FileWithContext.TYPE.OTHERS}`,
          },
        ]
        break
      case FileWithContext.CATEGORY.RH:
        new_type = defaultTypes.filter(
          (t) =>
            [
              FileWithContext.TYPE.RH_WORK_CONTRACT,
              FileWithContext.TYPE.RH_SECURITY,
              FileWithContext.TYPE.RH_MONITORING,
              FileWithContext.TYPE.RH_PENSION,
              FileWithContext.TYPE.OTHERS,
            ].indexOf(t.id) > -1
        )
        break
      case FileWithContext.CATEGORY.ACCOUNTING:
        new_type = defaultTypes.filter(
          (t) =>
            [
              FileWithContext.TYPE.QUOTE,
              FileWithContext.TYPE.INVOICE,
              FileWithContext.TYPE.INDIVIDUAL_BURDEN_DISTRIBUTIONS,
              FileWithContext.TYPE.BANK_STATEMENTS,
              FileWithContext.TYPE.OTHERS,
            ].indexOf(t.id) > -1
        )
        break
      case FileWithContext.CATEGORY.ADMINISTRATIVE:
        new_type = defaultTypes.filter(
          (t) =>
            [
              FileWithContext.TYPE.PV,
              FileWithContext.TYPE.PV_SIGNED,
              FileWithContext.TYPE.DESCRIPTIVE_STATEMENT_DIVISION,
              FileWithContext.TYPE.COOWNERSHIP_RULES,
              FileWithContext.TYPE.ASBESTOS_DIAGNOSIS,
              FileWithContext.TYPE.LEAD_DIAGNOSIS,
              FileWithContext.TYPE.TERMITE_DIAGNOSIS,
              FileWithContext.TYPE.PLAN,
              FileWithContext.TYPE.OTHERS,
            ].indexOf(t.id) > -1
        )
        break
      case FileWithContext.CATEGORY.TECHNICAL:
        new_type = defaultTypes.filter(
          (t) =>
            [
              FileWithContext.TYPE.QUOTE,
              FileWithContext.TYPE.INTERVENTION_REPORT,
              FileWithContext.TYPE.ANALYSIS_OR_EXPERT_REPORT,
              FileWithContext.TYPE.INTERVENTION_PHOTO,
              FileWithContext.TYPE.OTHERS,
            ].indexOf(t.id) > -1
        )
        break
      case FileWithContext.CATEGORY.LEGAL:
        new_type = defaultTypes.filter(
          (t) =>
            [
              FileWithContext.TYPE.RH_MONITORING,
              FileWithContext.TYPE.RH_PENSION,
              FileWithContext.TYPE.RH_SECURITY,
              FileWithContext.TYPE.RH_WORK_CONTRACT,
              FileWithContext.TYPE.OTHERS,
            ].indexOf(t.id) > -1
        )
        break
      case FileWithContext.CATEGORY.BUILDING:
        new_type = defaultTypes.filter(
          (t) =>
            [
              FileWithContext.TYPE.REGISTRATION,
              FileWithContext.TYPE.OTHERS,
              FileWithContext.TYPE.PPT,
              FileWithContext.TYPE.DPE,
              FileWithContext.TYPE.DTG,
            ].indexOf(t.id) > -1
        )
        break
      case FileWithContext.CATEGORY.INSURANCE:
        new_type = defaultTypes.filter(
          (t) =>
            [
              FileWithContext.TYPE.INSURANCE_CERTIFICATE,
              FileWithContext.TYPE.CONTRACT_INSURANCE,
              FileWithContext.TYPE.TERMS_AND_CONDITIONS,
              FileWithContext.TYPE.SPECIAL_CONDITIONS,
              FileWithContext.TYPE.INTERVENING_CONDITIONS,
              FileWithContext.TYPE.OTHERS,
            ].indexOf(t.id) > -1
        )
        break
      case FileWithContext.CATEGORY.OTHER:
        new_type = defaultTypes.filter(
          (t) => [FileWithContext.TYPE.OTHERS].indexOf(t.id) > -1
        )
        break
      case FileWithContext.CATEGORY.COMMUNICATION:
        new_type = defaultTypes.filter(
          (t) => [FileWithContext.TYPE.EMAIL].indexOf(t.id) > -1
        )
        break
    }
    return new_type
  }
  // Make types translatables.
  const defaultTypes = Object.values(validTypes || FileWithContext.TYPE)
    .map((id) =>
      typeof id === 'string'
        ? {
            id: id,
            name: `hs.file.type.${id}`,
          }
        : Object.values(id).map((sub_id) => ({
            id: sub_id,
            // Improve the subkey function in order to get the parent name
            name: `hs.file.type.contract.${sub_id}`,
          }))
    )
    .flat()
  const [types, setTypes] = useState(defaultTypes)
  // Make categories translatables.
  useEffect(() => {
    if (!types.length) {
      setInternalErrors((prev) => {
        return {
          ...prev,
          type: false,
        }
      })
    } else {
      setInternalErrors((prev) => {
        const { type, ...newVal } = prev
        return {
          ...newVal,
        }
      })
    }
  }, [record.category])
  const categories = (
    validCategories ? validCategories : Object.values(FileWithContext.CATEGORY)
  )
    .map((id) =>
      typeof id === 'string'
        ? {
            id: id,
            name: `hs.file.category.${id}`,
          }
        : Object.values(id).map((sub_id) => ({
            id: sub_id,
            // Improve the subkey function in order to get the parent name
            name: `hs.file.category.contract.${sub_id}`,
          }))
    )
    .flat()
  // Make invoice_type translatables.
  const invoice_type = (
    validAccountantType
      ? validAccountantType
      : Object.values(FileWithContext.INVOICE_TYPE)
  ).map((id) => ({
    id: id,
    name: `hs.file.invoice_type.${id}`,
  }))
  const handleTypeChange = (type) => {
    let tmpData = {}
    if (
      [
        FileWithContext.TYPE.QUOTE,
        FileWithContext.TYPE.INVOICE,
        FileWithContext.TYPE.INSURANCE_CERTIFICATE,
        FileWithContext.TYPE.CONTRACT.SYNDIC,
        FileWithContext.TYPE.CONTRACT.SYNDIC_SIGNED,
        FileWithContext.TYPE.LEAD_DIAGNOSIS,
        FileWithContext.TYPE.TERMITE_DIAGNOSIS,
        FileWithContext.TYPE.ASBESTOS_DIAGNOSIS,
        FileWithContext.TYPE.CONTRACT.ASSURANCE,
      ].indexOf(type) > -1
    )
      tmpData.deadline = null
    else tmpData.intervention_date = null

    return {
      type: type,
      ...tmpData,
    }
  }
  useEffect(() => {
    setRecords((records) => {
      if (categories.length === 1 && !record.category) {
        record.category = categories[0].id
        let new_types = filtreTypesByCategory(categories[0].id)
        setTypes(new_types)
      }
      if (types.length === 1 && !record.type) {
        record = { ...record, ...handleTypeChange(types[0].id) }
      }
      records[idx] = { ...record }
      if (formSubmited) {
        let tmpRequiredObj = {}
        Object.keys(requiredField).forEach((field) => {
          if (!record[field])
            tmpRequiredObj[field] = translate('hs.errors.missing', {
              propertyName: translate(
                `resources.file_with_context.fields.${field}`
              ),
            })
        })
        setInternalErrors((prev) => ({
          ...prev,
          ...tmpRequiredObj,
        }))
      }
      return [...records]
    })
    setPristine(false)
  }, [
    (categories.length === 1 && !record.category) ||
      (types.length === 1 && !record.type),
    formSubmited,
  ])

  const classes = useStyles()

  const defineCondo = async (getCondo) => {
    setIsMatchingCondo(true)
    setVerificationStatus(VERIFICATION_STATUS.IN_PROGRESS)
    const ibanRegex = /__(FR[0-9A-Z]{25})/i
    const accountRegex = /__([0-9A-Z]{11})/i

    const match =
      record.purpose?.match(ibanRegex) || record.purpose?.match(accountRegex)
    const ibanOrAccount = match ? match[1] : null

    try {
      const duplicateCheck = await Api.fileWithContext.checkDuplicate(
        record.purpose
      )
      if (duplicateCheck?.data && duplicateCheck.data.length > 0) {
        setInternalErrors((prev) => ({
          ...prev,
          coproId: 'DOCUMENT DÉJÀ UPLOADÉ',
        }))
        setIsMatchingCondo(false)
        return
      }

      const coproId = ibanOrAccount ? await getCondo(ibanOrAccount) : null
      if (coproId) {
        setRecords((records) =>
          records.map((record, index) =>
            index === idx ? { ...record, copro_id: coproId } : record
          )
        )
        setInternalErrors((prev) => ({
          ...prev,
          coproId: undefined,
        }))
      } else {
        setInternalErrors((prev) => ({
          ...prev,
          coproId: 'Pas de copropriété trouvée.',
        }))
      }
    } catch (error) {
      setInternalErrors((prev) => ({
        ...prev,
        coproId: 'Erreur lors de la vérification.',
      }))
    } finally {
      setIsMatchingCondo(false)
      setVerifiedCount((prev) => prev + 1)
    }
  }

  useEffect(() => {
    if (record.copro_id) {
      setInternalErrors((prev) => ({
        ...prev,
        coproId: undefined,
      }))
    }
  }, [record.copro_id])

  useEffect(() => {
    if (defaultValues.category) {
      setTypes(filtreTypesByCategory(defaultValues.category))
    }
    setRecords((records) =>
      records.map((record, index) =>
        index === idx ? { ...record, ...defaultValues } : record
      )
    )
    if (getDefaultCondo && !record.copro_id) {
      defineCondo(getDefaultCondo)
    }
  }, [])

  return (
    <Grid container spacing={2} px={3} className={classes.container}>
      <Grid item md={12} xs={12}>
        <Grid item md={1} className={classes.buttonsContainer}>
          {(idx < limitQuantity - 1 && isLast) ||
            (!limitQuantity && isLast && (
              <Button
                color="primary"
                variant="contained"
                size="small"
                onClick={(e) => {
                  e.preventDefault()
                  e.stopPropagation()
                  setCollapse(false)
                  setRecords((records) =>
                    records.concat({
                      copro_id: copro_id,
                      staff_id: staff_id,
                      provider: provider,
                      updated_at: moment().format('YYYY-MM-DD'),
                      issue_date: moment().format('YYYY-MM-DD'),
                      document_type: documentType ?? records[0]?.document_type,
                      issued_by: issuedBy ?? 'hello-app',
                      category:
                        categories.length === 1 ? categories[0].id : null,
                      type: types.length === 1 ? types[0].id : null,
                    })
                  )
                }}
              >
                <Add />
              </Button>
            ))}
          {!(idx === 0 && isLast) && (
            <Button
              color="primary"
              variant="contained"
              className={classes.deleteButton}
              onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()
                setRecords((records) => {
                  records.splice(idx, 1)

                  return [...records]
                })
              }}
            >
              <Delete />
            </Button>
          )}
        </Grid>
      </Grid>
      <Grid
        container
        spacing={2}
        px={3}
        className={classes.panel}
        style={{
          border: internalErrors['coproId'] ? '3px solid red' : undefined,
          color: internalErrors['coproId'] ? 'red' : undefined,
        }}
      >
        <Box
          sx={{
            width: '100%',
            margin: 8,
            display: 'flex',
          }}
        >
          <Box
            className={classes.panelContainer}
            onClick={() => {
              setCollapse(!collapse)
            }}
          >
            <Box>{record.id ? record.purpose : `Doc N° ${idx + 1}`}</Box>
            {internalErrors['coproId'] && internalErrors['coproId']}
            {collapse ? <CollapseExpandLessIcon /> : <CollapseMoreIcon />}
          </Box>
        </Box>
        {collapse && (
          <>
            <Grid md={12} xs={12}>
              <CoproInput
                showCoproSelection={showCoproSelection}
                record={record}
                onChange={(value) => {
                  setRecords((records) => {
                    records[idx] = { ...record, copro_id: value }
                    setPristine(false)
                    return [...records]
                  })
                }}
              />
              <Grid
                container
                item
                md={12}
                xs={12}
                style={{ padding: '16px' }}
                spacing={2}
              >
                <Grid item md={6} xs={12}>
                  <TextField
                    fullWidth
                    label={translate('hs.file.purpose')}
                    value={record.purpose}
                    required={requiredField['purpose']}
                    error={internalErrors['purpose']}
                    helperText={internalErrors['purpose']}
                    InputLabelProps={{ shrink: record.purpose ? true : false }}
                    disabled={readOnly}
                    onChange={(e) => {
                      e.persist()
                      e.stopPropagation()
                      e.preventDefault()
                      if (e.target.value)
                        setInternalErrors((prev) => ({
                          ...prev,
                          purpose: false,
                        }))
                      else
                        setInternalErrors((prev) => ({
                          ...prev,
                          purpose:
                            requiredField['purpose'] &&
                            translate('hs.errors.missing', {
                              propertyName: translate(
                                'resources.file_with_context.fields.purpose'
                              ),
                            }),
                        }))
                      setRecords((records) => {
                        records[idx] = { ...record, purpose: e.target.value }
                        setPristine(false)
                        return [...records]
                      })
                    }}
                    variant="outlined"
                  />
                </Grid>
                <Grid item md={6} xs={12}>
                  <FormControl
                    disabled={
                      readOnly || (categories.length === 1 && record.category)
                    }
                    fullWidth
                    className={classes.selectStyle}
                    error={internalErrors['category']}
                  >
                    <InputLabel shrink={record.category}>
                      {translate('hs.file.category.self_translation')}
                    </InputLabel>
                    <Select
                      value={record.category}
                      variant="outlined"
                      required={requiredField['category']}
                      onChange={(e) => {
                        e.persist()
                        e.stopPropagation()
                        e.preventDefault()
                        if (
                          Object.values(FileWithContext.CATEGORY).indexOf(
                            e.target.value
                          ) > -1
                        ) {
                          setInternalErrors((prev) => ({
                            ...prev,
                            category: false,
                          }))
                        } else {
                          setInternalErrors((prev) => ({
                            ...prev,
                            category:
                              requiredField['category'] &&
                              translate('hs.errors.missing', {
                                propertyName: translate(
                                  'resources.file_with_context.fields.category'
                                ),
                              }),
                          }))
                        }
                        let new_type = filtreTypesByCategory(e.target.value)
                        setTypes(new_type)
                        setRecords((records) => {
                          if (e.target) {
                            records[idx].category = e.target.value
                            records[idx].type =
                              new_type.length === 1 ? new_type[0].id : null
                            setPristine(false)
                          }

                          return [...records]
                        })
                      }}
                    >
                      {categories.map((c) => {
                        return (
                          <MenuItem value={c.id}>{translate(c.name)}</MenuItem>
                        )
                      })}
                    </Select>
                    <FormHelperText>
                      {internalErrors['category']}
                    </FormHelperText>
                  </FormControl>
                </Grid>
                <Grid item md={6} xs={12}>
                  <FormControl
                    disabled={readOnly || (types.length === 1 && record.type)}
                    fullWidth
                    className={classes.selectStyle}
                    error={internalErrors['type']}
                  >
                    <InputLabel shrink={record.type}>
                      {translate('hs.file.type.self_translation')}
                    </InputLabel>
                    <Select
                      value={record.type}
                      variant="outlined"
                      required={types.length ? requiredField['type'] : false}
                      onChange={(e) => {
                        e.persist()
                        e.stopPropagation()
                        e.preventDefault()
                        if (
                          Object.values(FileWithContext.TYPE)
                            .map((v) =>
                              typeof v === 'string' ? v : Object.values(v)
                            )
                            .flat()
                            .indexOf(e.target.value) > -1
                        )
                          setInternalErrors((prev) => ({
                            ...prev,
                            type: false,
                          }))
                        else
                          setInternalErrors((prev) => ({
                            ...prev,
                            type:
                              requiredField['type'] &&
                              translate('hs.errors.missing', {
                                propertyName: translate(
                                  'resources.file_with_context.fields.type'
                                ),
                              }),
                          }))
                        setRecords((records) => {
                          records[idx] = {
                            ...records[idx],
                            ...handleTypeChange(e.target.value),
                          }
                          setPristine(false)

                          return [...records]
                        })
                      }}
                    >
                      {types.map((t) => (
                        <MenuItem value={t.id}> {translate(t.name)}</MenuItem>
                      ))}
                    </Select>
                    <FormHelperText>{internalErrors['type']}</FormHelperText>
                  </FormControl>
                </Grid>
                <PrestaInput
                  showPrestaSelection={showPrestaSelection}
                  record={record}
                  onChange={(value) => {
                    setRecords((records) => {
                      records[idx] = { ...record, provider: value }
                      setPristine(false)
                      return [...records]
                    })
                  }}
                />
                <Grid item md={6} xs={12}>
                  <TextField
                    disabled={readOnly}
                    required={requiredField['updated_at']}
                    error={internalErrors['updated_at']}
                    helperText={internalErrors['updated_at']}
                    fullWidth
                    label={translate('hs.file.updated_at')}
                    type="date"
                    defaultValue={
                      record.updated_at
                        ? moment(record.updated_at).format('Y-MM-DD')
                        : null
                    }
                    onChange={(e) => {
                      e.persist()
                      e.preventDefault()
                      e.stopPropagation()
                      if (moment(e.target.value).isValid())
                        setInternalErrors((prev) => ({
                          ...prev,
                          updated_at: false,
                        }))
                      else
                        setInternalErrors((prev) => ({
                          ...prev,
                          updated_at:
                            requiredField['updated_at'] &&
                            translate('hs.errors.missing', {
                              propertyName: translate(
                                'resources.file_with_context.fields.updated_at'
                              ),
                            }),
                        }))
                      setRecords((records) => {
                        records[idx].updated_at = e.target.value
                        setPristine(false)

                        return [...records]
                      })
                    }}
                    sx={{ width: 220 }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    variant="outlined"
                  />
                </Grid>
                <Grid item md={6} xs={12}>
                  <TextField
                    disabled={readOnly}
                    required={requiredField['issue_date']}
                    error={internalErrors['issue_date']}
                    helperText={internalErrors['issue_date']}
                    fullWidth
                    label={translate('hs.file.issue_date')}
                    type="date"
                    defaultValue={
                      record.issue_date
                        ? moment(record.issue_date).format('Y-MM-DD')
                        : null
                    }
                    onChange={(e) => {
                      e.persist()
                      e.preventDefault()
                      e.stopPropagation()
                      if (moment(e.target.value).isValid())
                        setInternalErrors((prev) => ({
                          ...prev,
                          issue_date: false,
                        }))
                      else
                        setInternalErrors((prev) => ({
                          ...prev,
                          issue_date:
                            requiredField['issue_date'] &&
                            translate('hs.errors.missing', {
                              propertyName: translate(
                                'resources.file_with_context.fields.issue_date'
                              ),
                            }),
                        }))
                      setRecords((records) => {
                        if (e.target) {
                          records[idx].issue_date = e.target.value
                          setPristine(false)
                        }

                        return [...records]
                      })
                    }}
                    sx={{ width: 220 }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    variant="outlined"
                  />
                </Grid>
                {[FileWithContext.TYPE.INVOICE].indexOf(record.type) > -1 && (
                  <Grid item md={12}>
                    <FormControl
                      disabled={
                        readOnly ||
                        (invoice_type.length === 1 && record.invoice_type)
                      }
                      fullWidth
                      className={classes.invoice_type}
                      error={internalErrors['invoice_type']}
                    >
                      <InputLabel shrink={record.invoice_type}>
                        {translate('hs.file.invoice_type.self_translation')}
                      </InputLabel>
                      <Select
                        value={record.invoice_type}
                        variant="outlined"
                        required={requiredField['invoice_type']}
                        onChange={(e) => {
                          e.persist()
                          e.stopPropagation()
                          e.preventDefault()
                          if (
                            Object.values(FileWithContext.INVOICE_TYPE).indexOf(
                              e.target.value
                            ) > -1
                          )
                            setInternalErrors((prev) => ({
                              ...prev,
                              invoice_type: false,
                            }))
                          else
                            setInternalErrors((prev) => ({
                              ...prev,
                              invoice_type:
                                requiredField['invoice_type'] &&
                                translate('hs.errors.missing', {
                                  propertyName: translate(
                                    'resources.file_with_context.fields.invoice_type'
                                  ),
                                }),
                            }))
                          setRecords((records) => {
                            if (e.target) {
                              records[idx].invoice_type = e.target.value
                              setPristine(false)
                            }

                            return [...records]
                          })
                        }}
                      >
                        {invoice_type.map((ac) => (
                          <MenuItem value={ac.id}>
                            {translate(ac.name)}
                          </MenuItem>
                        ))}
                      </Select>
                      <FormHelperText>
                        {internalErrors['invoice_type']}
                      </FormHelperText>
                    </FormControl>
                  </Grid>
                )}
                {[
                  FileWithContext.TYPE.QUOTE,
                  FileWithContext.TYPE.INVOICE,
                  FileWithContext.TYPE.INSURANCE_CERTIFICATE,
                  FileWithContext.TYPE.CONTRACT.SYNDIC,
                  FileWithContext.TYPE.CONTRACT.SYNDIC_SIGNED,
                  FileWithContext.TYPE.LEAD_DIAGNOSIS,
                  FileWithContext.TYPE.TERMITE_DIAGNOSIS,
                  FileWithContext.TYPE.ASBESTOS_DIAGNOSIS,
                  FileWithContext.TYPE.CONTRACT.ASSURANCE,
                ].indexOf(record.type) > -1 && (
                  <>
                    <Grid item md={6} xs={12}>
                      <TextField
                        disabled={readOnly}
                        required={
                          requiredField['amount_incl_vat'] ? true : false
                        }
                        error={internalErrors['amount_incl_vat']}
                        helperText={internalErrors['amount_incl_vat']}
                        fullWidth
                        label={translate('hs.file.amount_incl_vat')}
                        defaultValue={record.amount_incl_vat}
                        onChange={(e) => {
                          e.persist()
                          e.preventDefault()
                          e.stopPropagation()
                          if (
                            /^[0-9]+([.,]{1}?[0-9]{2})?$/.test(e.target.value)
                          )
                            setRecords((records) => {
                              records[idx].amount_incl_vat = e.target.value
                              setInternalErrors((prev) => ({
                                ...prev,
                                issue_date: false,
                              }))
                              setPristine(false)
                              setInternalErrors((prev) => ({
                                ...prev,
                                amount_incl_vat: false,
                              }))

                              return [...records]
                            })
                          else
                            setInternalErrors((prev) => ({
                              ...prev,
                              amount_incl_vat: translate(
                                'hs.errors.invalid_number_format',
                                { value: e.target.value }
                              ),
                            }))
                        }}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item md={6} xs={12}>
                      <TextField
                        disabled={readOnly}
                        required={
                          requiredField['amount_excl_vat'] ? true : false
                        }
                        error={internalErrors['amount_excl_vat']}
                        helperText={internalErrors['amount_excl_vat']}
                        fullWidth
                        label={translate('hs.file.amount_excl_vat')}
                        defaultValue={record.amount_excl_vat}
                        onChange={(e) => {
                          e.persist()
                          e.preventDefault()
                          e.stopPropagation()
                          if (
                            /^[0-9]+([.,]{1}?[0-9]{2})?$/.test(e.target.value)
                          )
                            setInternalErrors((prev) => ({
                              ...prev,
                              amount_excl_vat: false,
                            }))
                          else
                            setInternalErrors((prev) => ({
                              ...prev,
                              amount_excl_vat: translate(
                                'hs.errors.invalid_number_format',
                                { value: e.target.value }
                              ),
                            }))
                          setRecords((records) => {
                            records[idx].amount_excl_vat = e.target.value
                            setPristine(false)

                            return [...records]
                          })
                        }}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item md={6} xs={12}>
                      <TextField
                        disabled={readOnly}
                        required={requiredField['deadline'] ? true : false}
                        error={internalErrors['deadline']}
                        helperText={internalErrors['deadline']}
                        fullWidth
                        label={translate('hs.file.deadline')}
                        type="date"
                        defaultValue={
                          record.deadline
                            ? moment(record.deadline).format('Y-MM-DD')
                            : null
                        }
                        onChange={(e) => {
                          e.persist()
                          e.preventDefault()
                          e.stopPropagation()
                          if (moment(e.target.value).isValid())
                            setInternalErrors((prev) => ({
                              ...prev,
                              deadline: false,
                            }))
                          else
                            setInternalErrors((prev) => ({
                              ...prev,
                              deadline:
                                requiredField['deadline'] &&
                                translate('hs.errors.missing', {
                                  propertyName: translate(
                                    'resources.file_with_context.fields.deadline'
                                  ),
                                }),
                            }))
                          setRecords((records) => {
                            records[idx].deadline = e.target.value
                            setPristine(false)

                            return [...records]
                          })
                        }}
                        sx={{ width: 220 }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        variant="outlined"
                      />
                    </Grid>
                  </>
                )}
                {[
                  FileWithContext.TYPE.INTERVENTION_REPORT,
                  FileWithContext.TYPE.ANALYSIS_OR_EXPERT_REPORT,
                ].indexOf(record.type) > -1 && (
                  <Grid item md={12}>
                    <TextField
                      disabled={readOnly}
                      required={
                        requiredField['intervention_date'] &&
                        !record.intervention_date
                          ? true
                          : false
                      }
                      error={internalErrors['intervention_date']}
                      helperText={internalErrors['intervention_date']}
                      fullWidth
                      label={translate('hs.file.intervention_date')}
                      type="date"
                      defaultValue={
                        record.intervention_date
                          ? moment(record.intervention_date).format('Y-MM-DD')
                          : null
                      }
                      onChange={(e) => {
                        e.persist()
                        e.preventDefault()
                        e.stopPropagation()
                        if (moment(e.target.value).isValid())
                          setInternalErrors((prev) => ({
                            ...prev,
                            intervention_date: false,
                          }))
                        else
                          setInternalErrors((prev) => ({
                            ...prev,
                            intervention_date:
                              requiredField['intervention_date'] &&
                              translate('hs.errors.missing', {
                                propertyName: translate(
                                  'resources.file_with_context.fields.intervention_date'
                                ),
                              }),
                          }))
                        setRecords((records) => {
                          if (e.target) {
                            records[idx].intervention_date = e.target.value
                            setPristine(false)
                          }
                          setInternalErrors((prev) => ({
                            ...prev,
                            intervention_date: false,
                          }))

                          return [...records]
                        })
                      }}
                      sx={{ width: 220 }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      variant="outlined"
                    />
                  </Grid>
                )}
                {show_shared_select && (
                  <Grid item md={12}>
                    <SharedSelect
                      source="shared"
                      record={record}
                      onChange={(e) => {
                        e.stopPropagation()
                        e.preventDefault()
                        setRecords((records) => {
                          if (
                            e.target &&
                            e.target.value &&
                            e.target.value.length >= 1
                          ) {
                            records[idx].shared = e.target.value
                            setPristine(false)
                          }

                          return [...records]
                        })
                      }}
                    />
                  </Grid>
                )}
                <Grid item md={12}>
                  {
                    // eslint-disable-next-line react/no-unknown-property
                    children && <children record={record} />
                  }
                </Grid>
                <Grid item md={12}>
                  <CustomFileInput
                    disabled={readOnly}
                    defaultValue={record.url || record.file}
                    onChange={([file]) => {
                      setRecords((records) => {
                        records[idx] = {
                          ...records[idx],
                          purpose: file.name,
                          file: file,
                        }
                        setPristine(false)

                        return [...records]
                      })
                    }}
                    multiple={false}
                    allowDownload={true}
                    label="hs.file.change_file"
                    dragNDropProps={{
                      style: {
                        background: 'transparent',
                        color: 'black',
                        border: 'dashed grey 3px',
                        borderRadius: '1rem',
                      },
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
          </>
        )}
      </Grid>
    </Grid>
  )
}

const VERIFICATION_STATUS = {
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
}

export const FileView = ({
  record,
  basePath,
  resource,
  saveResult = () => {},
  documentType,
  issuedBy,
  copro_id,
  provider,
  linkable_type,
  linkable_id,
  staff_id,
  defaultValue = [],
  height = defaultValue && defaultValue.length > 0 ? '100px' : '500px',
  shared = ['not'],
  upload_by,
  upload_by_type,
  showCoproSelection = false,
  showPrestaSelection = false,
  requiredField = {
    purpose: true,
    category: true,
    type: true,
    document_type: true,
    issued_by: true,
    issue_date: true,
    deadline: true,
    amount_incl_vat: true,
    amount_excl_vat: true,
    intervention_date: true,
    updated_at: true,
  },
  readOnly,
  globalDatePicker,
  ...props
}) => {
  const notify = useNotify()
  const translate = useTranslate()
  const [saving, setSaving] = useState(false)
  const [formSubmited, setFormSubmited] = useState(false)
  const [records, setRecords] = useState(defaultValue)
  const [internalErrors, setInternalErrors] = useState([])
  const [pristine, setPristine] = useState(true)
  const [uploaderHeight, seUploaderHeight] = useState(height)
  const dataProvider = useDataProvider()
  const [issueDate, setIssueDate] = useState(null)
  const [verificationStatus, setVerificationStatus] = useState(null)
  const [verifiedCount, setVerifiedCount] = useState(0)
  const [previousTotal, setPreviousTotal] = useState(0)
  const totalToVerify = props.getDefaultCondo ? records.length : 0

  useEffect(() => {
    if (!issueDate) return
    setRecords((records) =>
      records.map((record) => ({
        ...record,
        issue_date: issueDate ?? issueDate,
      }))
    )
  }, [issueDate])

  useEffect(() => {
    // If documents were added (totalToVerify > previousTotal)
    if (totalToVerify > previousTotal && totalToVerify > 0) {
      // Keep current counter, the new document will be verified and will increment
      setVerificationStatus(VERIFICATION_STATUS.IN_PROGRESS)
      setPreviousTotal(totalToVerify)
    }
    // If documents were removed (totalToVerify < previousTotal), adjust the counter
    else if (totalToVerify < previousTotal && totalToVerify > 0) {
      // If we already verified more than the new total, adjust
      if (verifiedCount > totalToVerify) {
        setVerifiedCount(totalToVerify)
        setVerificationStatus(VERIFICATION_STATUS.COMPLETED)
      }
      setPreviousTotal(totalToVerify)
    }
    // Verification completed
    else if (
      totalToVerify > 0 &&
      verifiedCount === totalToVerify &&
      verificationStatus !== VERIFICATION_STATUS.COMPLETED
    ) {
      setVerificationStatus(VERIFICATION_STATUS.COMPLETED)
    }
    // Verification in progress
    else if (
      totalToVerify > 0 &&
      verifiedCount > 0 &&
      verifiedCount < totalToVerify &&
      verificationStatus !== VERIFICATION_STATUS.IN_PROGRESS
    ) {
      setVerificationStatus(VERIFICATION_STATUS.IN_PROGRESS)
    }
  }, [verifiedCount, totalToVerify])

  if (!showCoproSelection && !copro_id)
    return <p>La copropriété est nécessaire.</p>
  if (!showPrestaSelection && !provider && props.expectProvider)
    return <p>Le fournisseur est nécessaire.</p>

  const missingCondos = records.some((record) => !record.copro_id)

  return (
    <>
      <Grid item md={12} xs={12}>
        <h3>
          {records.length > 1
            ? translate('hs.file.dialog_title', { quantity: records.length })
            : `${records.length} document sélectionné`}
        </h3>
        {verificationStatus && (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
              padding: '5px',
              backgroundColor:
                verificationStatus === VERIFICATION_STATUS.IN_PROGRESS
                  ? '#f5f5f5'
                  : '#e8f5e9',
              border:
                verificationStatus === VERIFICATION_STATUS.IN_PROGRESS
                  ? '1px solid #ccc'
                  : '1px solid #4caf50',
              borderRadius: '5px',
              marginBottom: '10px',
            }}
          >
            {verificationStatus === VERIFICATION_STATUS.IN_PROGRESS && (
              <CircularProgress size={24} thickness={4} />
            )}
            <span>
              {verificationStatus === VERIFICATION_STATUS.IN_PROGRESS
                ? `Vérification des documents en cours... (${verifiedCount}/${totalToVerify})`
                : 'Vérification des documents terminée'}
            </span>
          </Box>
        )}
        {globalDatePicker && records.length > 0 && (
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <DatePicker
              label="Date des documents"
              onChange={(value) => {
                setIssueDate(value.format('YYYY-MM-DD'))
              }}
            />
          </LocalizationProvider>
        )}
        {records.length === 0 && (
          <CustomFileInput
            acceptOnly={props.acceptOnly ? props.acceptOnly : '*'}
            icon={<CloudUploadIcon />}
            multiple={true}
            height={uploaderHeight}
            defaultValue={records.map((record) => record.file || record.url)}
            onChange={(files) => {
              setRecords(
                files.map((file) => {
                  let result = {
                    document_type: documentType,
                    issued_by: issuedBy,
                    file: file,
                    copro_id: copro_id,
                    staff_id: staff_id,
                    provider: provider,
                    purpose: file.name,
                    updated_at: moment().format('YYYY-MM-DD'),
                    issue_date: moment().format('YYYY-MM-DD'),
                    category: null,
                    type: null,
                  }
                  return result
                })
              )
              seUploaderHeight('100px')
            }}
          />
        )}
        {records.map((r, idx) => (
          <BasicForm
            {...props}
            key={r.id || r.file?.src || idx}
            record={r}
            setRecords={setRecords}
            setPristine={setPristine}
            idx={idx}
            copro_id={copro_id}
            staff_id={staff_id}
            provider={provider}
            isLast={records.length === idx + 1}
            issuedBy={issuedBy}
            documentType={documentType}
            requiredField={requiredField}
            readOnly={readOnly}
            setInternalErrors={setInternalErrors}
            internalErrors={internalErrors}
            formSubmited={formSubmited}
            showCoproSelection={showCoproSelection}
            showPrestaSelection={showPrestaSelection}
            setVerificationStatus={setVerificationStatus}
            setVerifiedCount={setVerifiedCount}
          />
        ))}
      </Grid>
      {records.length > 0 && !readOnly && (
        <Toolbar
          style={{
            background: 'transparent',
            position: 'unset',
            padding: 0,
          }}
        >
          <Button
            color="primary"
            variant="contained"
            fullWidth
            disabled={
              saving ||
              pristine ||
              missingCondos ||
              verificationStatus === VERIFICATION_STATUS.IN_PROGRESS
            }
            onClick={(e) => {
              setSaving(true)
              setFormSubmited(false)
              e.preventDefault()
              e.stopPropagation()
              const result = new FileWithContextResult()
              try {
                const promises = []
                records.forEach((r, idx) => {
                  const record = new FileWithContext(
                    {
                      ...r,
                      shared:
                        r.shared && r.shared.length >= 1 ? r.shared : shared,
                      upload_by,
                      upload_by_type,
                    },
                    {
                      ...requiredField,
                    }
                  )
                  if (linkable_type && linkable_id)
                    record.relation = new Relation({
                      linkable_type,
                      linkable_id,
                    })
                  promises.push(
                    new Promise((resolve, reject) => {
                      record.file
                        .then((file) => {
                          if (record.id)
                            dataProvider
                              .update(resource, {
                                id: record.id,
                                data: {
                                  ...record.toJSON(),
                                  file,
                                },
                              })
                              .then(({ data }) => {
                                result.accepted_file = new FileWithContext(data)
                                resolve(result)
                              })
                              .catch((e) => {
                                result.rejected_file = record
                                if (409 === e.status)
                                  reject(new ErrorUpload(e.body))
                                else reject(new ServerUpload(e))
                              })
                          else
                            dataProvider
                              .create(resource, {
                                data: {
                                  ...record.toJSON(),
                                  file,
                                },
                              })
                              .then(({ data }) => {
                                // @todo: change this get when the data is successfuly populated by
                                // react admin dataProvider. Somehow is returing the given record but with the new id.
                                dataProvider
                                  .getOne(resource, { id: data.id })
                                  .then(({ data }) => {
                                    result.accepted_file = Object.assign(
                                      record,
                                      data
                                    )
                                    resolve(result)
                                  })
                              })
                              .catch((e) => {
                                result.rejected_file = record
                                if (409 === e.status)
                                  reject(new ErrorUpload(e.body))
                                else reject(new ServerUpload(record))
                              })
                              .finally(() => {
                                setSaving(false)
                              })
                        })
                        .catch((e) => {
                          notify(translate(e.message, e.values), 'error')
                          setSaving(false)
                        })
                    })
                  )
                })
                Promise.all(promises)
                  .then(() => {
                    saveResult(result)
                    setSaving(false)
                    setPristine(true)
                  })
                  .catch((e) => {
                    notify(translate(e.message, e.values), 'error')
                    setSaving(false)
                  })
              } catch (e) {
                setFormSubmited(true)
                notify(
                  translate('hs.errors.missing', {
                    propertyName: translate(
                      `resources.file_with_context.fields.${e.values.propertyName}`
                    ),
                  }),
                  'error'
                )
                setSaving(false)
              }
            }}
          >
            {saving ? (
              <CircularProgress size={18} thickness={2} />
            ) : verificationStatus === VERIFICATION_STATUS.IN_PROGRESS ? (
              <>Vérification en cours...</>
            ) : missingCondos ? (
              <>Des informations sont manquantes</>
            ) : (
              <>
                {translate('ra.action.save')} &nbsp;{' '}
                <Emoji label="ok" symbol="👌" />
              </>
            )}
          </Button>
        </Toolbar>
      )}
    </>
  )
}

export const CustomFileDetailTable = ({ rows, responsive = false }) => {
  const translate = useTranslate()
  const random = Math.random().toString()

  const handleTextTypeOrCat = (colName, cell) => {
    const types = Object.values(FileWithContext.TYPE)
      .map((id) =>
        typeof id === 'string'
          ? {
              id: id,
              name: `hs.file.type.${id}`,
            }
          : Object.values(id).map((sub_id) => ({
              id: sub_id,
              name: `hs.file.type.contract.${sub_id}`,
            }))
      )
      .flat()
    if (colName == 'category') {
      if (!cell) {
        return ''
      }
      return translate(`hs.file.${colName}.${cell}`)
    }
    cell = types.find((item) => item.id == cell)?.name
    const txt = cell ? translate(`${cell}`) : ''
    return txt
  }
  const headerColumns = rows && rows.length ? Object.keys(rows[0]) : []
  const theme = useTheme()
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'))
  return rows && rows.length > 0 ? (
    <TableContainer style={{ marginTop: '16px' }}>
      <Table size="small" aria-label="a dense table">
        <TableHead>
          <TableRow>
            {headerColumns.map((column, idx) => (
              <TableCell
                style={{
                  textAlign:
                    ['url', 'preview_document', 'preview_annexes'].indexOf(
                      column
                    ) > -1
                      ? 'center'
                      : 'left',
                  display:
                    responsive &&
                    isSmallScreen &&
                    ['type', 'category'].includes(column)
                      ? 'none'
                      : '',
                }}
                key={`header-${random}-${idx}`}
              >
                {translate(`resources.file_with_context.fields.${column}`)}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, idx) => (
            <TableRow key={`detail-${idx}-${random}`}>
              {Object.entries(row).map(([colName, cell]) =>
                colName.indexOf('preview') > -1 ? (
                  <TableCell
                    key={`cell-${random}-${idx}-${colName}`}
                    component="th"
                    scope="row"
                    style={{ textAlign: 'center' }}
                  >
                    {row[colName] && (
                      <PreviewButton record={row} source={colName} />
                    )}
                  </TableCell>
                ) : 'url' === colName ? (
                  <TableCell
                    key={`cell-${random}-${idx}-${colName}`}
                    component="th"
                    scope="row"
                    style={{ textAlign: 'center' }}
                  >
                    <UrlFieldDownload
                      record={row}
                      source={colName}
                      download={true}
                    />
                  </TableCell>
                ) : (
                  <TableCell
                    key={`cell-${random}-${idx}-${colName}`}
                    component="th"
                    scope="row"
                    style={{
                      display:
                        ['type', 'category'].indexOf(colName) > -1 &&
                        responsive &&
                        isSmallScreen
                          ? 'none'
                          : '',
                    }}
                  >
                    {['type', 'category'].indexOf(colName) > -1 ? (
                      handleTextTypeOrCat(colName, cell)
                    ) : (
                      <TextFieldWithTooltip
                        record={row}
                        maxLength={50}
                        source={colName}
                      />
                    )}
                  </TableCell>
                )
              )}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  ) : null
}

export const SaveNewWithFileButton = ({
  resource,
  basePath,
  redirect,
  record,
  ...props
}) => {
  return <SaveButton {...props} />
}

/**
 * This verify if there are files for the given related entity and if there are returns
 * a link to list them otherwise it returns nothing.
 *
 * @param { id, linkable_type } props
 *
 * @returns JSX.Element || Boolean
 */
export const LinkRelationFromParent = ({
  linkable_id,
  linkable_type,
  show_on_modal,
  show_shared_select,
  allow_add,
}) => {
  const [show_list_dialog, set_show_list_dialog] = useState(false)
  const [show_button, set_show_button] = useState(false)
  useEffect(() => {
    Api.fileWithContext
      .getCount({
        filter: JSON.stringify({
          linkable_id,
          linkable_type,
        }),
        range: '{}',
      })
      .then((res) => {
        if (res.data.count && res.data.count > 0) {
          set_show_button(true)
        }
      })
  }, [show_on_modal !== true])

  return !show_on_modal ? (
    !show_button && (
      <Link
        target="_blank"
        onClick={(e) => {
          e.stopPropagation()
        }}
        to={{
          pathname: 'file_with_context',
          search: `filter=${JSON.stringify({
            linkable_id: linkable_id,
            linkable_type,
          })}`,
        }}
        icon={<AttachFile />}
      />
    )
  ) : show_button && linkable_id ? (
    <>
      <Button
        component="div"
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
          set_show_list_dialog(true)
        }}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '4px',
          minWidth: 'auto',
        }}
      >
        <AttachFile />
      </Button>
      <Dialog
        onClose={() => {
          set_show_list_dialog(false)
        }}
        fullWidth
        maxWidth="xl"
        open={show_list_dialog}
      >
        <ListFileView
          resource="file_with_context"
          basePath="/file_with_context"
          filter={{
            linkable_id,
            linkable_type,
          }}
          allow_add={allow_add}
          modal_view={true}
          show_shared_select={show_shared_select}
        />
      </Dialog>
    </>
  ) : (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '4px',
        minWidth: 'auto',
      }}
    >
      <AttachFile color="disabled" />
    </div>
  )
}

export const SignedRelation = () => {
  const record = useRecordContext()
  if (record) {
    if (record.sending_proof || record.signature_proof) {
      return (
        <div style={{ display: 'inline-flex' }}>
          {record.sending_proof && <SendingButton source="sending_proof" />}
          {record.signature_proof && (
            <SignatureButton source="signature_proof" />
          )}
        </div>
      )
    } else {
      if (record.letter_id) return <PendingActionsIcon />
    }
  }
  return null
}

export const LinkRelation = () => {
  const record = useRecordContext()
  if (record && record.linkable_type)
    return (
      <Link
        target="_blank"
        onClick={(e) => {
          e.stopPropagation()
        }}
        to={{
          pathname: `/${
            'ag' === record.linkable_type ? 'ags1a' : record.linkable_type
          }`,
          search: `displayedFilters=${encodeURIComponent(
            JSON.stringify({
              id: true,
            })
          )}&filter=${encodeURIComponent(
            JSON.stringify({ id: record.linkable_id })
          )}`,
        }}
      >
        <AttachFile />
      </Link>
    )

  return <LinkOff />
}

export const UrlFieldDownload = ({
  record: PropertyRecord,
  source,
  download,
  isBase64File = false,
}) => {
  const record = PropertyRecord || useRecordContext()

  if (record)
    return (
      <a
        style={{ padding: 'inherit' }}
        href={
          isBase64File
            ? `data:application/octet-stream;base64,${record[source]}`
            : record[source]
        }
        download={download}
      >
        <CloudDownload color="primary" />
      </a>
    )
  return null
}

const ListFileFilter = ({
  types,
  linkable_types,
  document_types,
  categories,
}) => [
  <TextInput label="Libelle" source="purpose" alwaysOn />,
  <TextInput source="copromatic_id" label="Code copromatic" />,
  <SearchInput source="copro_code" />,
  <SearchInput source="prestataire_name" />,
  // @todo: find a way to use the translator package for filters.
  <TextInput source="id" label="Ref. document" />,
  <SelectInput
    label="Type d'entité liée"
    source="linkable_type"
    allowEmpty
    emptyValue={null}
    choices={linkable_types}
  />,
  <TextInput
    label="ID d'entité liée"
    source="linkable_id"
    allowEmpty
    emptyValue={null}
  />,
  <SelectInput
    label="Type"
    source="type"
    allowEmpty
    emptyValue={null}
    choices={types}
  />,
  <SelectInput
    label="Categorie"
    source="category"
    allowEmpty
    emptyValue={null}
    choices={categories}
  />,
  <SelectInput
    label="Type de document"
    source="document_type"
    allowEmpty
    emptyValue={null}
    choices={document_types}
  />,
  <TextInput label="Copropriété" source="copro" allowEmpty emptyValue={null} />,
  <TextInput
    label="Copropriétaire"
    source="coowner"
    allowEmpty
    emptyValue={null}
  />,
  <NumberInput
    label="Code copromatic"
    source="copro_copromatic_id"
    allowEmpty
    emptyValue={null}
  />,
  <BooleanInput source="archived_at" />,
]

export const UpdateShared = () => {
  const record = useRecordContext()
  const refresh = useRefresh()
  const notify = useNotify()
  const translate = useTranslate()
  if (!record) return null
  const [update, { isLoading }] = useUpdate()
  const handleChange = (e) => {
    e.preventDefault()
    e.stopPropagation()
    if (e.target.value.length === 0) return
    update(
      'file_with_context',
      {
        id: record.id,
        data: {
          shared: e.target.value,
        },
        previousData: record,
      },
      {
        onSuccess: () => {
          refresh()
          notify(translate('hs.file.success.update_ext'), 'success')
        },
        onFailure: (error) =>
          notify(translate('hs.file.error.update_ext'), 'warning'),
      }
    )
  }

  return <SharedSelect record={record} onChange={handleChange} />
}

const SharedSelect = ({ record, onChange = () => {} }) => {
  const translate = useTranslate()
  return (
    <Select
      name="shared"
      value={
        Array.isArray(record.shared)
          ? record.shared
          : (record.shared || '{not}').replace(/[{}]/g, '').split(',')
      }
      variant="outlined"
      onChange={onChange}
      multiple
      renderValue={(selected) => (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
          {selected.map((value) => (
            <Chip key={value} label={translate(`hs.file.shared.${value}`)} />
          ))}
        </Box>
      )}
    >
      <MenuItem value="not" disabled>
        {translate('hs.file.shared.not')}
      </MenuItem>
      <MenuItem value="coowners">
        {translate('hs.file.shared.coowners')}
      </MenuItem>
      <MenuItem value="providers">
        {translate('hs.file.shared.providers')}
      </MenuItem>
      <MenuItem value="cs_members">
        {translate('hs.file.shared.cs_members')}
      </MenuItem>
    </Select>
  )
}

const PreviewDialog = ({
  onClose,
  open,
  source,
  record: ParentRecord,
  isBase64File = false,
}) => {
  const record = ParentRecord || useRecordContext()
  if (!record) return null

  return (
    <Dialog
      onClick={(e) => e.stopPropagation()}
      onClose={onClose}
      fullWidth="true"
      maxWidth="md"
      open={open}
    >
      <embed
        src={`${isBase64File ? 'data:application/pdf;base64,' : ''}${
          record[source] ? record[source] : record.url
        }#toolbar=0`}
        type="application/pdf"
        width="1000px"
        height="600px"
      />
    </Dialog>
  )
}

export const SendingButton = ({
  record: ParentRecord,
  source,
  isBase64File,
}) => {
  const record = ParentRecord || useRecordContext()
  const [openPreview, setOpenPreview] = useState(false)

  return (
    <div style={{ textAlign: 'center' }}>
      <ReceiptIcon
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
          setOpenPreview(true)
        }}
        color="primary"
      />
      {openPreview && (
        <PreviewDialog
          onClose={() => {
            setOpenPreview(false)
          }}
          open={openPreview}
          record={record}
          source={source}
          isBase64File={isBase64File}
        />
      )}
    </div>
  )
}

export const SignatureButton = ({
  record: ParentRecord,
  source,
  isBase64File,
}) => {
  const record = ParentRecord || useRecordContext()
  const [openPreview, setOpenPreview] = useState(false)

  return (
    <div style={{ textAlign: 'center' }}>
      <VerifiedIcon
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
          setOpenPreview(true)
        }}
        color="primary"
      />
      {openPreview && (
        <PreviewDialog
          onClose={() => {
            setOpenPreview(false)
          }}
          open={openPreview}
          record={record}
          source={source}
          isBase64File={isBase64File}
        />
      )}
    </div>
  )
}

export const PreviewButton = ({
  record: ParentRecord,
  source,
  isBase64File,
  icon = VisibilityIcon,
  previewOnNewTab = false,
}) => {
  const record = ParentRecord || useRecordContext()
  const [openPreview, setOpenPreview] = useState(false)

  return (
    <IconButton>
      <VisibilityIcon
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
          if (previewOnNewTab) {
            openInNewTab(record[source] ? record[source] : record.url)
          } else {
            setOpenPreview(true)
          }
        }}
        color="primary"
      />
      {openPreview && (
        <PreviewDialog
          onClose={() => {
            setOpenPreview(false)
          }}
          open={openPreview}
          record={record}
          source={source}
          isBase64File={isBase64File}
        />
      )}
    </IconButton>
  )
}

export const ArchiveButton = () => {
  const record = useRecordContext()
  if (!record) return null

  const refresh = useRefresh()
  const notify = useNotify()
  const translate = useTranslate()
  const [update, { isLoading }] = useUpdate(
    'file_with_context',
    {
      id: record.id,
      data: { archived_at: record.archived_at ? null : new Date() },
      previousData: record,
    },
    {
      onSuccess: () => {
        refresh()
        notify(translate('hs.file.success.archive'), 'success')
      },
      onFailure: (error) =>
        notify(translate('hs.file.error.archive'), 'warning'),
    }
  )

  return record.archived_at ? (
    <Unarchive
      color="primary"
      disabled={isLoading}
      onClick={(e) => {
        e.preventDefault()
        e.stopPropagation()
        update()
      }}
    />
  ) : (
    <Delete
      color="primary"
      disabled={isLoading}
      onClick={(e) => {
        e.preventDefault()
        e.stopPropagation()
        update()
      }}
    />
  )
}

export const ActionButtons = () => {
  return (
    <Grid container>
      <Grid item xs={3} style={{ width: '60px', textAlign: 'center' }}>
        <UrlFieldDownload source="url" download={true} />
      </Grid>
      <Grid item xs={3} style={{ width: '60px', textAlign: 'center' }}>
        <PreviewButton source="preview_document" />
      </Grid>
      <Grid item xs={3} style={{ width: '60px', textAlign: 'center' }}>
        <SignedRelation />
      </Grid>
      <Grid item xs={3} style={{ width: '60px', textAlign: 'center' }}>
        <ArchiveButton source="archive" />
      </Grid>
    </Grid>
  )
}

const BulkUpdateSharedButton = ({
  value,
  selectedRecords,
  translate,
  update,
  disabled,
  refresh,
  notify,
  onUnselectItems,
}) => {
  const handleClick = () => {
    for (const record of selectedRecords) {
      const currentSharedValue = Array.isArray(record.shared)
        ? record.shared
        : (record.shared || '{not}').replace(/[{}]/g, '').split(',')

      const newSharedValue = currentSharedValue.includes(value)
        ? currentSharedValue.filter((val) => val !== value)
        : [...currentSharedValue, value]

      if (!newSharedValue.length) continue

      update(
        'file_with_context',
        {
          id: record.id,
          data: { shared: newSharedValue },
          previousData: record,
        },
        {
          onSuccess: () => {
            refresh()
            notify(translate('hs.file.success.update_ext'), 'success')
          },
          onFailure: () =>
            notify(translate('hs.file.error.update_ext'), 'warning'),
        }
      )
    }

    onUnselectItems()
  }

  return (
    <BulkUpdateButton
      label={translate(`hs.file.shared.${value}`)}
      value={value}
      disabled={disabled}
      onClick={handleClick}
      onSuccess={() => null}
    />
  )
}

const BulkDownloadButton = ({ selectedRecords, onUnselectItems }) => {
  const anchorElements = useRef({})

  const anchors = selectedRecords.map((record) => (
    <a
      key={record.id}
      href={record.url}
      download
      ref={(el) => (anchorElements.current[`a-${record.id}`] = el)}
      style={{ display: 'none' }}
    />
  ))

  const handleClick = () => {
    for (const key in anchorElements.current) {
      const anchor = anchorElements.current[key]

      if (anchor) anchor.click()
    }

    onUnselectItems()
  }

  return (
    <>
      <BulkExportButton label="Télécharger" onClick={handleClick} />
      {anchors}
    </>
  )
}

const BulkActionButtons = () => {
  const { selectedIds, data, onUnselectItems } = useListContext()
  const translate = useTranslate()
  const [update] = useUpdate()
  const refresh = useRefresh()
  const notify = useNotify()

  const selectedRecords = data.filter((record) =>
    selectedIds.includes(record.id)
  )

  const bulkUpdateSharedButtons = ['not', 'coowners', 'providers'].map(
    (value) => (
      <BulkUpdateSharedButton
        key={value}
        value={value}
        selectedRecords={selectedRecords}
        translate={translate}
        update={update}
        disabled={value === 'not'}
        refresh={refresh}
        notify={notify}
        onUnselectItems={onUnselectItems}
      />
    )
  )

  return (
    <>
      {bulkUpdateSharedButtons}
      <BulkDownloadButton
        selectedRecords={selectedRecords}
        onUnselectItems={onUnselectItems}
      />
    </>
  )
}

export const ListFileView = (props) => {
  const [editData, setEditData] = useState([])
  const notify = useNotify()
  const translate = useTranslate()
  const refresh = useRefresh()
  const dataProvider = useDataProvider()
  // This is necesary in order to avoid the modal being opened when
  // the user click on a actionable component. ex: Button/Switch.
  const [showEditDialog, setShowEditDialog] = useState(false)
  const { data, isLoading, error } = useGetOne('file_with_context', {
    id: 'choices',
  })

  if (isLoading) {
    return <Loading />
  }

  let tr = (context, key) => ({
    id: key,
    name: translate(`hs.file.${context}.${key}`),
  })
  let types = data.types.map((t) => tr('type', t))
  let linkable_types = data.linkable_types.map((t) => tr('linkable_type', t))
  let document_types = data.document_types.map((t) => tr('document_type', t))
  let categories = data.categories.map((t) => tr('category', t))

  return (
    <>
      <List
        {...props}
        exporter={false}
        hasCreate={false}
        hasEdit={true}
        disableSyncWithLocation={props.modal_view ? true : false}
        actions={
          <Grid
            container
            alignItems="flex-end"
            style={{
              padding: '10px 0px',
            }}
          >
            <Grid item xs={5}>
              {!props.modal_view && (
                <FilterForm
                  filters={ListFileFilter({
                    types,
                    linkable_types,
                    document_types,
                    categories,
                  })}
                />
              )}
            </Grid>
            {(props.allow_add == undefined || props.allow_add) && (
              <Grid
                item
                xs={4}
                style={{
                  textAlign: 'right',
                }}
                spacing={1}
                container
              >
                <Grid item>
                  <UpsertFileButton
                    labelButton="Ajouter des relevés bancaires"
                    resource="file_with_context"
                    documentType={FileWithContext.DOCUMENT_TYPE.COPRO}
                    issuedBy={FileWithContext.ISSUED_BY.HELLO_APP}
                    previewAttachedFiles={false}
                    showPrestaSelection={true}
                    showCoproSelection={true}
                    globalDatePicker
                    saveResult={(result) => {
                      if (
                        result.accepted_files.length > 0 &&
                        result.rejected_files.length === 0
                      ) {
                        refresh()
                      }
                    }}
                    show_shared_select={true}
                    defaultCollapsed={true}
                    defaultValues={{
                      category: FileWithContext.CATEGORY.ACCOUNTING,
                      type: FileWithContext.TYPE.BANK_STATEMENTS,
                      shared: [
                        FileWithContext.SHARED.NOT,
                        FileWithContext.SHARED.CS_MEMBERS,
                      ],
                    }}
                    getDefaultCondo={async (iban) => {
                      try {
                        const res = await Api.copros.getByIban(iban)
                        return res.data?.condoId ?? null
                      } catch (error) {
                        console.error(error)
                      }
                      return null
                    }}
                  />
                </Grid>
                <Grid item>
                  <UpsertFileButton
                    resource="file_with_context"
                    documentType={FileWithContext.DOCUMENT_TYPE.COPRO}
                    issuedBy={FileWithContext.ISSUED_BY.HELLO_APP}
                    previewAttachedFiles={false}
                    showPrestaSelection={true}
                    showCoproSelection={true}
                    saveResult={(result) => {
                      if (
                        result.accepted_files.length > 0 &&
                        result.rejected_files.length === 0
                      ) {
                        refresh()
                      }
                    }}
                    show_shared_select={true}
                  />
                </Grid>
              </Grid>
            )}
            {!props.modal_view && (
              <Grid
                item
                xs={2}
                style={{
                  textAlign: 'right',
                }}
              >
                <FilterButton
                  filters={ListFileFilter({
                    types,
                    linkable_types,
                    document_types,
                    categories,
                  })}
                />
              </Grid>
            )}
          </Grid>
        }
      >
        <Datagrid
          bulkActionButtons={<BulkActionButtons />}
          rowClick={(id, basePath, record) => {
            const catetgoryId = categories.find(
              (c) => translate(c.name) === record.category
            )
            const typeId = types.find((t) => translate(t.name) === record.type)
            record = {
              ...record,
              type: typeId?.id,
              category: catetgoryId?.id,
            }
            setEditData([record])
            setShowEditDialog(true)
          }}
        >
          {!props.modal_view && <LinkRelation source="related_entity" />}
          <UpdateShared source="shared" />
          <TranslateWrapperTextField source="category" prefix={'hs.file'}>
            <TextFieldRa />
          </TranslateWrapperTextField>
          <TranslateWrapperTextField source="type" prefix={'hs.file'}>
            <TextFieldRa />
          </TranslateWrapperTextField>
          <TextFieldRa source="document_type" />
          <TextFieldRa source="issued_by" />
          <DateField source="issue_date" />
          <DateField source="deadline" />
          <TextFieldRa source="amount_incl_vat" />
          <TextFieldRa source="amount_excl_vat" />
          <TextFieldWithTooltip maxLength={20} source="purpose" />
          <ActionButtons source="actions" />
        </Datagrid>
      </List>
      {showEditDialog && editData.length > 0 && (
        <UpsertFileDialog
          {...props}
          handleUpsertClose={(e) => {
            setEditData([])
            setShowEditDialog(false)
          }}
          showPrestaSelection={true}
          showCoproSelection={true}
          showUpsertDialog={showEditDialog}
          saveResult={(result) => {
            if (result.rejected_files.length > 0) {
              result.rejected_files.forEach((rejectedFile) => {
                notify(
                  translate(
                    rejectedFile.message,
                    ...rejectedFile.internalValues
                  ),
                  'error'
                )
              })
            } else if (result.accepted_files.length > 0) {
              setEditData([])
              refresh()
            }
          }}
          defaultValue={editData}
        />
      )}
    </>
  )
}

export const FormFile = ({ id, resource, basePath, ...props }) => (
  <Container>
    <FileView resource={resource} basePath={basePath} {...props} />
  </Container>
)

export const EditHandler = ({ id, resource, basePath, open, ...props }) => {
  const dataProvider = useDataProvider()
  const [editData, setEditData] = useState()
  useEffect(() => {
    dataProvider
      .getOne(resource, {
        id: id,
      })
      .then((result) => {
        setEditData([result.data])
      })
  }, [])

  return editData ? (
    <FileView
      {...props}
      resource={resource}
      basePath={basePath}
      defaultValue={editData}
    />
  ) : (
    <div name="loading-edit-data"></div>
  )
}

export const UpsertFileDialog = ({
  handleUpsertClose,
  showUpsertDialog,
  resource = 'file_with_context',
  basePath,
  saveResult,
  defaultValue,
  ...props
}) => {
  return (
    <Dialog
      onClick={(e) => e.stopPropagation()}
      onClose={handleUpsertClose}
      fullWidth
      maxWidth="md"
      open={showUpsertDialog}
    >
      <FormFile
        resource={resource}
        basePath={basePath}
        saveResult={saveResult}
        defaultValue={defaultValue}
        {...props}
      />
      <Notification />
    </Dialog>
  )
}

/**
 * This functionality adds a button and a modal that will open also added in this component with the file widget
 *
 * @param {
 *  open,
 *  resource,
 *  basePath,
 *  saveResult: Function<FileWithContextResult>
 * } props
 *
 * @returns
 */
const UpsertFileButton = ({
  expectProvider = false,
  fromPath = 'file_with_context',
  resource,
  basePath,
  defaultValue,
  fullWidthButton,
  saveResult: parentSaveResult = () => {},
  open = false,
  previewAttachedFiles = true,
  showCoproSelection = false,
  showPrestaSelection = false,
  globalDatePicker = false,
  ...props
}) => {
  const notify = useNotify()
  const translate = useTranslate()
  const [showUpsertDialog, setShowUpsertDialog] = useState(open || false)
  const [values, setValues] = useState([])
  useEffect(() => {
    setValues(defaultValue)
  }, [defaultValue])
  const handleUpsertClose = (e) => {
    e.stopPropagation()
    setShowUpsertDialog(false)
  }
  const handleUpsertShow = (e) => {
    e.stopPropagation()
    setShowUpsertDialog(true)
  }
  const saveResult = (result) => {
    if (result.rejected_files.length > 0) {
      result.rejected_files.forEach((rejectedFile) => {
        // @todo: check the way to improve the exception handling at the moment we do not throw them and just translate the message
        notify(
          translate(rejectedFile.message, ...rejectedFile.internalValues),
          'error'
        )
      })
    } else if (result.accepted_files.length > 0) {
      if (fromPath !== 'file_with_context') {
        setValues(result.accepted_files)
      }
      setShowUpsertDialog(false) // We only close the modal if all files are uploaded.
    }
    parentSaveResult(result)
  }

  return (
    <div>
      <Button
        color="primary"
        variant="contained"
        fullWidth={fullWidthButton}
        onClick={handleUpsertShow}
      >
        {props.labelButton
          ? props.labelButton
          : translate('hs.file.open_dialog')}
      </Button>
      <UpsertFileDialog
        handleUpsertClose={handleUpsertClose}
        showUpsertDialog={showUpsertDialog}
        resource={resource}
        basePath={basePath}
        saveResult={saveResult}
        defaultValue={values}
        showCoproSelection={showCoproSelection}
        showPrestaSelection={showPrestaSelection}
        fromPath={fromPath}
        expectProvider={expectProvider}
        globalDatePicker={globalDatePicker}
        {...props}
      />
      {values && values.length > 0 && previewAttachedFiles && (
        <CustomFileDetailTable
          rows={values.map(({ url, purpose, category, type }) => ({
            purpose,
            category,
            type,
            preview_document: url,
            url,
          }))}
        />
      )}
    </div>
  )
}

export default UpsertFileButton
